import { __awaiter, __decorate, __param } from 'tslib';
import { CommonModule } from '@angular/common';
import { Injectable, Optional, SkipSelf, NgModule } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { BaseService, PasswordValidator, DocumentValidator, DateValidator, ErrorMessageService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeNWalletProxy, SpeViewNWalletProxy, SpeViewNAccountProxy, SpeJCheckEventProxy, ConfigService, UiPxCardsModule } from '@wlp/ui-px-cards';

let CardsService = class CardsService extends BaseService {
    constructor(formBuilder, speNWalletProxy, speViewNWalletProxy, speViewNAccountProxy, speJCheckEventProxy, storage, configService, errorMessageService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.speNWalletProxy = speNWalletProxy;
        this.speViewNWalletProxy = speViewNWalletProxy;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.speJCheckEventProxy = speJCheckEventProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.errorMessages = {
            document: [
                {
                    type: 'required',
                    message: 'CARDS.CARD_MANAGER.CARDS_DOCUMENT.FORM_ERROS.MESSAGE.REQUIRED',
                },
                {
                    type: 'cnpjNotValid',
                    message: 'CARDS.CARD_MANAGER.CARDS_DOCUMENT.FORM_ERROS.MESSAGE.CNPJ_NOT_VALID',
                },
                {
                    type: 'cpfNotValid',
                    message: 'CARDS.CARD_MANAGER.CARDS_DOCUMENT.FORM_ERROS.MESSAGE.CPF_NOT_VALID',
                },
            ],
        };
        this.errorMessagesPassword = {
            currentPassword: [
                {
                    type: 'required',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CURRENT_PASSWORD.REQUIRED',
                },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CURRENT_PASSWORD.MIN_LENGTH',
                    param: {
                        minLength: 4,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CURRENT_PASSWORD.MAX_LENGTH',
                    param: {
                        maxLength: 4,
                    },
                },
            ],
            newPassword: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.NEW_PASSWORD.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.NEW_PASSWORD.MIN_LENGTH',
                    param: {
                        minLength: 4,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.NEW_PASSWORD.MAX_LENGTH',
                    param: {
                        maxLength: 4,
                    },
                },
                {
                    type: 'equality',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.NEW_PASSWORD.EQUALITY',
                },
            ],
            confirmNewPassword: [
                {
                    type: 'required',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CONFIRM_NEW_PASSWORD.REQUIRED',
                },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CONFIRM_NEW_PASSWORD.MIN_LENGTH',
                    param: {
                        minLength: 4,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CONFIRM_NEW_PASSWORD.MAX_LENGTH',
                    param: {
                        maxLength: 4,
                    },
                },
                {
                    type: 'equality',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CONFIRM_NEW_PASSWORD.EQUALITY',
                },
            ],
        };
        this.errorMessagesActiveCard = {
            cardNumber: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.MIN_LENGTH',
                    param: {
                        minLength: 16,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.MAX_LENGTH',
                    param: {
                        maxLength: 16,
                    },
                },
            ],
            validThru: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.MIN_LENGTH',
                    param: {
                        minLength: 6,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.MAX_LENGTH',
                    param: {
                        maxLength: 6,
                    },
                },
            ],
            cvv: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CVV.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CVV.MIN_LENGTH',
                    param: {
                        minLength: 3,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CVV.MAX_LENGTH',
                    param: {
                        maxLength: 3,
                    },
                },
            ],
            document: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.DOCUMENT.REQUIRED' },
                {
                    type: 'cnpjNotValid',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.DOCUMENTS.MESSAGE.CNPJ_NOT_VALID',
                },
                {
                    type: 'cpfNotValid',
                    message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.FORM.DOCUMENTS.MESSAGE.CPF_NOT_VALID',
                },
            ],
            dddCellphone: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.DDD_CELLPHONE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.DDD_CELLPHONE.MIN_LENGTH',
                    param: {
                        minLength: 2,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.DDD_CELLPHONE.MAX_LENGTH',
                    param: {
                        maxLength: 2,
                    },
                },
            ],
            cellphone: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CELLPHONE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.DDD_CELLPHONE.MIN_LENGTH',
                    param: {
                        minLength: 2,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.DDD_CELLPHONE.MAX_LENGTH',
                    param: {
                        maxLength: 2,
                    },
                },
            ],
            carriersName: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARRIERS_NAME.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARRIERS_NAME.MIN_LENGTH',
                    param: {
                        minLength: 6,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARRIERS_NAME.MAX_LENGTH',
                    param: {
                        maxLength: 60,
                    },
                },
            ],
            birthDate: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.BIRTHDATE.REQUIRED' },
                {
                    type: 'validDate',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.BIRTHDATE.DATE_NOT_VALID',
                },
                {
                    type: 'ptDate',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.BIRTHDATE.DATE_NOT_VALID',
                },
            ],
        };
        this.errorMessagesNumberCard = {
            cardNumber: [
                {
                    type: 'required',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CONFIRM_NEW_PASSWORD.REQUIRED',
                },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CONFIRM_NEW_PASSWORD.MIN_LENGTH',
                    param: {
                        minLength: 6,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_PASSWORD.FORM_CARD_PASSWORD.CONFIRM_NEW_PASSWORD.MAX_LENGTH',
                    param: {
                        maxLength: 6,
                    },
                },
            ],
        };
    }
    cardExtract(uuidWhiteLabel, uuidAccount, card, initialDate, finalDate) {
        return __awaiter(this, void 0, void 0, function* () {
            let extract = [];
            yield this.speViewNWalletProxy
                .cardExtract(uuidWhiteLabel, uuidAccount, card, initialDate, finalDate)
                .toPromise()
                .then((res) => {
                extract = res;
            })
                .catch((err) => this.getError(err));
            let response = !!extract ? extract : null;
            return Promise.resolve(response);
        });
    }
    getCards(uuidWhiteLabel, uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                yield this.speViewNWalletProxy
                    .getCards(uuidWhiteLabel, uuidAccount)
                    .toPromise()
                    .then((res) => {
                    const response = !!res ? res : null;
                    resolve(response);
                })
                    .catch((err) => reject(this.getError(err)));
            }));
        });
    }
    getCardsStatus(uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let cards;
            yield this.speViewNWalletProxy
                .getCardsStatus(uuidAccount)
                .toPromise()
                .then((res) => {
                cards = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cards ? cards : null;
            return Promise.resolve(response);
        });
    }
    createformCardPassword() {
        this.formCardPassword = this.formBuilder.group({
            currentPassword: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.hasEmptySpace,
                Validators.minLength(4),
                Validators.maxLength(4),
            ])),
            newPassword: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.hasEmptySpace,
                Validators.minLength(4),
                Validators.maxLength(4),
            ])),
            confirmNewPassword: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.hasEmptySpace,
                Validators.minLength(4),
                Validators.maxLength(4),
            ])),
        });
        return this.formCardPassword;
    }
    createFormActiveCard() {
        this.activeCardForm = this.formBuilder.group({
            cardNumber: new FormControl('', Validators.compose([Validators.required, Validators.minLength(19), Validators.maxLength(19)])),
            validThru: new FormControl('', Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(7), validateDate])),
            cvv: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(3)])),
            document: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
            dddCellphone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(4)])),
            cellphone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(10)])),
            carriersName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(60)])),
            birthDate: new FormControl('', Validators.compose([Validators.required, DateValidator.ptDate, DateValidator.validDate])),
        });
        return this.activeCardForm;
    }
    createNumberCardForm() {
        this.numberCardForm = this.formBuilder.group({
            cardNumber: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(6)])),
        });
        return this.numberCardForm;
    }
    createformCard() {
        this.formCard = this.formBuilder.group({
            document: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCPFCNPJ, Validators.minLength(14)])),
        });
        return this.formCard;
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    getFormMessageErrorPassword() {
        return this.errorMessagesPassword;
    }
    getFormMessageActiveCard() {
        return this.errorMessagesActiveCard;
    }
    getFormNumberCardModal() {
        return this.errorMessagesNumberCard;
    }
    clearFormatDocument(document) {
        return document.replace(/[^\w\s]/gi, '');
    }
    requestCard(uuidWhiteLabel, uuidAccount, authentication) {
        return __awaiter(this, void 0, void 0, function* () {
            let requestCardResponse;
            yield this.speNWalletProxy
                .requestCard(uuidWhiteLabel, uuidAccount, authentication)
                .toPromise()
                .then((res) => {
                requestCardResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!requestCardResponse ? requestCardResponse : null;
            return Promise.resolve(response);
        });
    }
    validateDocument(uuidAccount, document) {
        return __awaiter(this, void 0, void 0, function* () {
            let documentNoFormat = document.replace(/[^\w\s]/gi, '');
            let validDocument;
            yield this.speNWalletProxy
                .confirmDocument(uuidAccount, documentNoFormat)
                .toPromise()
                .then((res) => {
                validDocument = res;
                // console.log("return", validDocument);
            })
                .catch((err) => this.getError(err));
            let response = !!validDocument ? validDocument : null;
            return Promise.resolve(response);
        });
    }
    activeCard(uuidWhiteLabel, uuidAccount, card) {
        return __awaiter(this, void 0, void 0, function* () {
            let cardResponse;
            yield this.speNWalletProxy
                .activeCard(uuidWhiteLabel, uuidAccount, card)
                .toPromise()
                .then((res) => {
                cardResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardResponse ? cardResponse : null;
            return Promise.resolve(response);
        });
    }
    activeCardNoName(uuidWhiteLabel, cardNoName) {
        return __awaiter(this, void 0, void 0, function* () {
            let cardResponse;
            yield this.speNWalletProxy
                .activeCardNoName(uuidWhiteLabel, cardNoName)
                .toPromise()
                .then((res) => {
                cardResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardResponse ? cardResponse : null;
            return Promise.resolve(response);
        });
    }
    blockCard(uuidWhiteLabel, uuidAccount, card) {
        return __awaiter(this, void 0, void 0, function* () {
            let cardResponse;
            yield this.speNWalletProxy
                .blockCard(uuidWhiteLabel, uuidAccount, card)
                .toPromise()
                .then((res) => {
                cardResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardResponse ? cardResponse : null;
            return Promise.resolve(response);
        });
    }
    cancelCard(uuidWhiteLabel, uuidAccount, card) {
        return __awaiter(this, void 0, void 0, function* () {
            let cardResponse;
            yield this.speNWalletProxy
                .cancelCard(uuidWhiteLabel, uuidAccount, card)
                .toPromise()
                .then((res) => {
                cardResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardResponse ? cardResponse : null;
            return Promise.resolve(response);
        });
    }
    unlockCard(uuidWhiteLabel, uuidAccount, card) {
        return __awaiter(this, void 0, void 0, function* () {
            let cardResponse;
            yield this.speNWalletProxy
                .unlockCard(uuidWhiteLabel, uuidAccount, card)
                .toPromise()
                .then((res) => {
                cardResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardResponse ? cardResponse : null;
            return Promise.resolve(response);
        });
    }
    changePassword(uuidWhiteLabel, uuidAccount, pass) {
        return __awaiter(this, void 0, void 0, function* () {
            let cardResponse;
            yield this.speNWalletProxy
                .changePassword(uuidWhiteLabel, uuidAccount, pass)
                .toPromise()
                .then((res) => {
                cardResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardResponse ? cardResponse : null;
            return Promise.resolve(response);
        });
    }
    createWallet(uuidWhiteLabel, uuidAccount, card) {
        return __awaiter(this, void 0, void 0, function* () {
            let cardResponse;
            yield this.speNWalletProxy
                .createWallet(uuidWhiteLabel, uuidAccount, card)
                .toPromise()
                .then((res) => {
                cardResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardResponse ? cardResponse : null;
            return Promise.resolve(response);
        });
    }
    validateOperation(uuidWhiteLabel, uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let sendingBody;
            let validateResponse;
            //get card issuer
            let issuer = 'edenred';
            yield this.speViewNAccountProxy
                .getCardIssuer(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                if (res && res.issuer) {
                    issuer = res.issuer;
                }
            })
                .catch((err) => this.getError(err));
            sendingBody = {
                uuidAccountPayment: uuidAccount,
                uuidWhiteLabel: uuidWhiteLabel,
                valueOperation: 0,
            };
            switch (issuer) {
                case 'orbital':
                    sendingBody.codeOperation = '1018';
                    break;
                default:
                    //edenred
                    sendingBody.codeOperation = '1003';
                    break;
            }
            yield this.speJCheckEventProxy
                .validateOperation(sendingBody)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    checkRequisitionInProgress(uuidAccount, document) {
        return __awaiter(this, void 0, void 0, function* () {
            let validateResponse;
            yield this.speViewNWalletProxy
                .checkRequisitionInProgress(uuidAccount, document)
                .toPromise()
                .then((res) => {
                validateResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!validateResponse ? validateResponse : null;
            return Promise.resolve(response);
        });
    }
    getCardTax(uuidWhiteLabel, uuidAccountPayment) {
        return __awaiter(this, void 0, void 0, function* () {
            let cardTaxResponse;
            let taxCode;
            //by default use issuer as EDENRED
            let issuer = 'edenred';
            yield this.speViewNAccountProxy
                .getCardIssuer(uuidWhiteLabel)
                .toPromise()
                .then((res) => {
                if (res && res.issuer) {
                    issuer = res.issuer;
                }
            })
                .catch((err) => this.getError(err));
            //check issuer and change to correct tax code
            switch (issuer) {
                case 'orbital':
                    taxCode = '713';
                    break;
                default:
                    //edenred
                    taxCode = '705';
                    break;
            }
            yield this.speViewNAccountProxy
                .getCardTax(uuidWhiteLabel, uuidAccountPayment, taxCode)
                .toPromise()
                .then((res) => {
                cardTaxResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardTaxResponse ? cardTaxResponse : null;
            return Promise.resolve(response);
        });
    }
    sendActivateCardNoName(uuidWhiteLabel, uuidAccountPayment, form) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = form.getRawValue();
            let dataActivate = {
                uuidAccountPayment: uuidAccountPayment,
                cardNumber: data.cardNumber.replaceAll(' ', ''),
                validThru: data.validThru,
                cvv: data.cvv,
                document: data.document.replace(/[^\w\s]/gi, ''),
                dddCellphone: data.dddCellphone,
                cellphone: data.cellphone,
                name: data.carriersName,
                birthDate: data.birthDate,
                cardStatus: data.cardStatus,
            };
            let cardNoNameResponse;
            yield this.speNWalletProxy
                .activeCardNoName(uuidWhiteLabel, dataActivate)
                .toPromise()
                .then((res) => {
                cardNoNameResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardNoNameResponse ? cardNoNameResponse : null;
            return Promise.resolve(response);
        });
    }
    getAccountDataReduceWithAddress(uuidAccountPayment) {
        return this.speViewNAccountProxy.getAccountDataReduceWithAddress(uuidAccountPayment);
    }
    requestVirtualCard(uuidWhiteLabel, uuidAccountPayment, data) {
        return __awaiter(this, void 0, void 0, function* () {
            let cardResponse;
            yield this.speNWalletProxy
                .requestVirtualCard(uuidWhiteLabel, uuidAccountPayment, data)
                .toPromise()
                .then((res) => {
                cardResponse = res;
            })
                .catch((err) => this.getError(err));
            let response = !!cardResponse ? cardResponse : null;
            return Promise.resolve(response);
        });
    }
    consultVirtualCard(data, uuidWhiteLabel, uuidAccountPayment) {
        return this.speViewNWalletProxy.consultVirtualCard(data, uuidWhiteLabel, uuidAccountPayment);
    }
    showPassword(uuidWhiteLabel, uuidAccountPayment, body) {
        return this.speNWalletProxy.showPassword(uuidWhiteLabel, uuidAccountPayment, body);
    }
};
CardsService.ctorParameters = () => [
    { type: FormBuilder },
    { type: SpeNWalletProxy },
    { type: SpeViewNWalletProxy },
    { type: SpeViewNAccountProxy },
    { type: SpeJCheckEventProxy },
    { type: Storage },
    { type: ConfigService },
    { type: ErrorMessageService }
];
CardsService = __decorate([
    Injectable()
], CardsService);
function validateDate(control) {
    let validThru = control.value;
    let arryDate = validThru.split('/');
    let currencyDate = new Date();
    if (Number(arryDate[0]) >= 1 && Number(arryDate[0]) <= 12) {
        if (Number(arryDate[1]) === currencyDate.getFullYear()) {
            if (Number(arryDate[0]) >= currencyDate.getMonth() + 1) {
                return null;
            }
            else {
                return { validThru: true };
            }
        }
        else if (Number(arryDate[1]) >= currencyDate.getFullYear()) {
            return null;
        }
        else {
            return { validThru: true };
        }
    }
    else
        return { validThru: true };
}

var UiBsCardsModule_1;
let UiBsCardsModule = UiBsCardsModule_1 = class UiBsCardsModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsCardsModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsCardsModule.ctorParameters = () => [
    { type: UiBsCardsModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsCardsModule = UiBsCardsModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            UiPxCardsModule,
            UiBsUtilModule,
            RxReactiveFormsModule
        ],
        providers: [
            CardsService,
        ],
        exports: [RxReactiveFormsModule]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsCardsModule);

class CardsResponse {
}

class AccountPaymentPersonDto {
}

class CardConsultResultDto {
}

/*
 * Public API Surface of ui-bs-cards
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountPaymentPersonDto, CardConsultResultDto, CardsResponse, CardsService, UiBsCardsModule, validateDate };
//# sourceMappingURL=wlp-ui-bs-cards.js.map
